import { createSlice } from "@reduxjs/toolkit";
import { BusinessDetailsData } from "../types/VerBusinessDetailsType";
import { getKeyPersonDetails } from "../action/getKeyPersonDetails";

const initialState: BusinessDetailsData = {
  data: null,
  loading: false,
  error: null,
  successfull: false,
};

const verIndividualDetailsSlice = createSlice({
  name: "verIndividualDetailsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getKeyPersonDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getKeyPersonDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // // console.log("DATA createAppSlice", action);
      })
      .addCase(getKeyPersonDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const verIndividualDetailsReducer = verIndividualDetailsSlice.reducer;
